export function isOwnBrandAcervoTeaser(objective?: string | null): boolean {
  return objective === 'own_brand';
}
